import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '../../launch/components/Tooltip';
import { intlShape } from 'react-intl';
import { getComponentClasses } from '@99designs/common/utils/app';

export default class extends React.Component {
    static propTypes = {
        onClick: PropTypes.func,
        disabled: PropTypes.bool,
        selected: PropTypes.bool,
        tooltipMessageId: PropTypes.string,
        meta: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        variations: PropTypes.array,
    };

    static contextTypes = {
        intl: intlShape.isRequired,
    };

    static defaultProps = {
        disabled: false,
        selected: false,
        tooltipMessageId: '',
        variations: [],
    };

    state = {
        showTooltip: false,
    };

    onClick = e => {
        if (this.props.disabled) {
            return;
        }

        if (this.props.onClick) {
            this.props.onClick(e);
        }
    };

    showTooltip = () => {
        if (this.props.tooltipMessageId) {
            this.refs.tooltip.positionRelativeTo(this.refs.frame);
            this.setState({
                showTooltip: true,
            });
        }
    };

    hideTooltip = () => {
        if (this.props.tooltipMessageId) {
            this.setState({
                showTooltip: false,
            });
        }
    };

    renderTooltipMessage = () => {
        if (this.props.tooltipMessageId) {
            return (
                <Tooltip visible={this.state.showTooltip} ref="tooltip" maxWidth={200} offset={-40}>
                    {this.renderFormattedMessage(this.props.tooltipMessageId)}
                </Tooltip>
            );
        }
    };

    renderMetaData = () => {
        if (this.props.meta) {
            return <div className="mediabox__meta-data">{this.props.meta}</div>;
        }
    };

    shouldComponentUpdate(nextProps, nextState) {
        return (
            nextProps.children != this.props.children ||
            nextProps.disabled !== this.props.disabled ||
            nextProps.selected !== this.props.selected ||
            nextState.showTooltip !== this.state.showTooltip
        );
    }

    renderFormattedMessage = messageId => {
        const { formatMessage } = this.context.intl;
        return messageId ? formatMessage({ id: messageId }) : '';
    };

    render() {
        const classes = getComponentClasses('mediabox', this.props.variations);
        const metaData = this.renderMetaData();

        let design = (
            <div
                onMouseOver={this.showTooltip}
                onMouseOut={this.hideTooltip}
                className={classes}
                data-disabled={this.props.disabled}
                data-selected={this.props.selected}
                data-testid="mediabox"
            >
                <div className="mediabox__media-frame" onClick={this.onClick} ref="frame">
                    <div className="mediabox__media" data-testid="mediabox__media">
                        {this.props.children}
                    </div>
                </div>

                {metaData}
                {this.renderTooltipMessage()}
            </div>
        );

        return design;
    }
}
